export const checkIfRulesEditMode = () => {
  const editingRules = document.querySelectorAll("section[data-attr-edit]");
  const error = document.querySelector('p[id="data-rules-edit"]');

  const areRulesNotInEditMode = editingRules.length > 0;

  if (areRulesNotInEditMode) {
    error?.classList.add("error-edit-display");
  } else {
    error?.classList.remove("error-edit-display");
  }

  return areRulesNotInEditMode;
};

export const markEditResolved = (path: string) => {
  const element = document.querySelector(`section[data-attr-edit="${path}"]`);
  element?.removeAttribute("data-attr-edit");

  checkIfRulesEditMode();
};
